{
  "language": {
    "title": "Choose your language",
    "en": "English",
    "nl": "Dutch",
    "sr": "Serbian",
    "fr": "French",
    "de": "German",
    "pt": "Portuguese"
  },
  "home": {
    "welcomeMessage": "Hello there, what brings you here today?",
    "checkIn": "Check in",
    "independentManualCheckIn": "No Appointment",
    "integratedManualCheckIn": "Check in manually",
    "checkOut": "Check out",
    "manualCheckOut": "Check out manually",
    "parcelDelivery": "Parcel delivery",
    "foodDelivery": "Food delivery",
    "callReception": "Call reception",
    "overview": "Overview",
    "unavailable": "The reception is currently unavailable."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Choose an option to check in",
        "manual": "Check in manually",
        "code": "Check in with PIN/QR code"
      },
      "checkout": {
        "title": "Choose an option to check out",
        "manual": "Check out with name",
        "code": "Check out with PIN/QR code"
      }
    },
    "title": "Waiting to scan your QR code.<br/>No QR code? No problem.",
    "orText": "OR",
    "qrScanner": {
      "checkin": {
        "title": "Choose an option to check in"
      },
      "checkout": {
        "title": "Choose an option to check out"
      },
      "btn": "Scan your QR code"
    },
    "pinCode": "Enter your PIN code",
    "manually": {
      "checkin": "Don't have credentials?"
    },
    "status": {
      "idle": {
        "title": "Your code is scanning.",
        "message": "Please wait..."
      },
      "loading": {
        "title": "Your code is scanning.",
        "message": "Please wait..."
      },
      "error": {
        "title": "Your code is invalid.",
        "message": "Please try again!"
      },
      "success": {
        "checkin": {
          "default": {
            "title": "You have successfully checked in.",
            "message": "Thank you."
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "You have successfully checked in.",
              "message": "Thank you."
            },
            "email-sms": {
              "title": "You have succesfully checked in.",
              "message": "Your contact person is notified."
            },
            "call-ping": {
              "title": "You have successfully checked in.",
              "message": "A telephone connection will now be made to your contact person."
            }
          },
          "Employee": {
            "title": "You have successfully checked in.",
            "message": "Thank you."
          },
          "Visitor": {
            "title": "You have successfully checked in.",
            "message": "Thank you."
          }
        },
        "checkout": {
          "default": {
            "title": "You have successfully checked out.<br/>",
            "message": "See you again soon."
          },
          "MeetingAttendee": {
            "title": "You have successfully checked out.",
            "message": "See you again soon."
          },
          "Employee": {
            "title": "You have successfully checked out.",
            "message": "See you again soon."
          },
          "Visitor": {
            "title": "You have successfully checked out.",
            "message": "See you again soon."
          }
        }
      }
    }
  },
  "manualCheckin": {
    "title": "Please fill in.",
    "subtitle": "Note - Every field * is required to be filled in",
    "noOption": "No option",
    "btn": "Check in",
    "placeholder": {
      "name": "Your name *",
      "email": "Your e-mail *",
      "phone": "Mobile number",
      "contactName": "Your contact name *"
    },
    "error": {
      "required": "You didn't fill in this field",
      "name": "Invalid name",
      "email": "Invalid email address",
      "phone": "Invalid mobile number"
    },
    "status": {
      "loading": {
        "title": "Please wait...",
        "message": "Your contact is being notified."
      },
      "success": {
        "no-email-sms": {
          "title": "You have successfully checked in.",
          "message": "Thank you."
        },
        "email-sms": {
          "title": "You have succesfully checked in.",
          "message": "Your contact person is notified."
        },
        "call-ping": {
          "title": "You are successfully checked in.",
          "message": "A telephone connection will now be made to your contact person."
        }
      },
      "error": {
        "title": "Something went wrong.",
        "message": "Please try again!"
      }
    }
  },
  "manualCheckout": {
    "title": "Enter your name to checkout",
    "btn": "Check out",
    "form": {
      "placeholder": {
        "name": "Your full name *"
      },
      "loading": "Loading...",
      "noOptions": "No options"
    },
    "error": {
      "required": "You didn't fill in this field",
      "name": "Invalid name"
    },
    "status": {
      "loading": {
        "title": "We are scanning your information.",
        "message": "Please wait..."
      },
      "success": {
        "title": "You have successfully checked out.",
        "message": "Thank you and have a nice day."
      },
      "error": {
        "title": "An error occurred while checking out.",
        "message": "Please try again!"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Do you want to notify your contact?",
      "email-sms": "We sent an email/sms to your contact.<br/>Do you want to notify them additionally?"
    },
    "callBtn": "Call",
    "pingBtn": "Ping",
    "smsBtn": "SMS",
    "callVideoBtn": "Video call",
    "noBtn": "Cancel",
    "cancelBtn": "Cancel call",
    "status": {
      "connecting": {
        "title": "Establishing call.<br/>Please wait...",
        "message": ""
      },
      "ringing": {
        "title": "Calling your contact<br/>Please wait...",
        "message": ""
      },
      "ringingReception": {
        "title": "Calling reception.<br/>Please wait...",
        "message": ""
      },
      "open": {
        "title": "Call in progress.",
        "message": ""
      },
      "close": {
        "title": "Call ended.<br/>Please wait for your contact.",
        "message": ""
      },
      "closeReception": {
        "title": "Call is ended.",
        "message": ""
      },
      "error": {
        "title": "Call is not established.<br/>Call again?",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "We are notifying the contact.",
        "message": "Please wait..."
      },
      "loading": {
        "title": "We are notifying the contact.",
        "message": "Please wait..."
      },
      "success": {
        "title": "SMS is sent. The contact is notified.",
        "message": "Thank you!"
      },
      "error": {
        "title": "SMS not sent.",
        "message": "Please try again!"
      }
    }
  },
  "videoCall": {
    "title": "Video call",
    "endCall": "END CALL",
    "status": {
      "idle": {
        "title": "We are creating a video room.",
        "message": "Please wait..."
      },
      "loading": {
        "title": "We are creating a video room.",
        "message": "Please wait..."
      },
      "success": {
        "title": "The video room has been successfully created.",
        "message": "Joining room..."
      },
      "error": {
        "title": "The video room was not created successfully.",
        "message": "Please try again!"
      }
    }
  },
  "packageDelivery": {
    "title": "How nice of you to deliver a package!",
    "subtitle": "Select and notify the recipient",
    "subtitle1": "Press the button below to let us know you are here! ",
    "subtitle2": "You can leave the package at the counter.",
    "input": {
      "label": {
        "contact": "Who is the parcel for"
      },
      "error": {
        "contact": {
          "required": "You didn't fill in this field"
        }
      }
    },
    "button": {
      "submit": "Notify"
    },
    "status": {
      "loading": {
        "title": "We are notifying the contact.",
        "message": "Please wait..."
      },
      "success": {
        "no-email-sms": {
          "title": "Thank you for your delivery!",
          "message": ""
        },
        "email-sms": {
          "title": "The contact is notified.",
          "message": "Thank you for your delivery!"
        },
        "call-ping": {
          "title": "Thank you for your delivery!",
          "message": "A telephone connection will now be made to your contact person."
        }
      },
      "error": {
        "title": "Something went wrong.",
        "message": "Please try again!"
      }
    }
  },
  "foodDelivery": {
    "title": "How nice of you to deliver food!",
    "subtitle": "Select and notify the recipient",
    "subtitle1": "Press the button below to let us know you are here! ",
    "subtitle2": "You can leave the food at the counter.",
    "input": {
      "label": {
        "contact": "Who is the food for"
      },
      "error": {
        "contact": {
          "required": "You didn't fill in this field"
        }
      }
    },
    "button": {
      "submit": "Notify"
    },
    "status": {
      "loading": {
        "title": "We are notifying the contact.",
        "message": "Please wait!"
      },
      "success": {
        "no-email-sms": {
          "title": "Thank you for your delivery!",
          "message": ""
        },
        "email-sms": {
          "title": "The contact is notified.",
          "message": "Thank you for your delivery!"
        },
        "call-ping": {
          "title": "Thank you for your delivery!",
          "message": "A telephone connection will now be made to your contact person."
        }
      },
      "error": {
        "title": "Something went wrong.",
        "message": "Please try again!"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Please scan your QR code",
    "subtitle": "Line up the QR code inside the red corners and keep your phone steady."
  },
  "common": {
    "backBtn": "Back"
  },
  "previewPDF": {
    "page": {
      "of": "of",
      "previous": "Previous",
      "next": "Next"
    },
    "button": {
      "cancel": "Cancel",
      "accept": "Accept",
      "next": "Next"
    },
    "title": {
      "consent": "Consent required"
    }
  },
  "offline": {
    "title": "Offline",
    "receptionMessage": "The reception is offline at the moment and can not be used, the internet connection must be checked!",
    "check": "Are you a visitor and do you want to speak to an employee directly? Please call {{receptionistPhone}}"
  },
  "overview": {
    "title": "Enter the code to open the overview!",
    "noUsers": "No users",
    "status": {
      "success": {
        "title": "The code is valid.",
        "message": ""
      },
      "error": {
        "title": "The code isn't valid.",
        "message": "Please try again!"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Please wait...",
        "message": ""
      },
      "success": {
        "title": "Successful check out.",
        "message": ""
      },
      "error": {
        "title": "Something went wrong.",
        "message": "Please try again!"
      }
    },
    "listTitle": "List of persons who checked in today but didn't check out",
    "page": "Page ",
    "table": {
      "head": {
        "fullName": "Name",
        "type": "Type",
        "checkedinAt": "Checked in at",
        "host": "Host"
      },
      "type": {
        "Package": "Package delivery",
        "Food": "Food delivery",
        "Visitor": "Visitor",
        "MeetingAttendee": "Invited visitor",
        "Employee": "Employee",
        "Guest": "Guest"
      }
    },
    "confirmModal": {
      "title": "Are you sure you want to check out {{fullName}}?",
      "cancel": "Cancel",
      "checkout": "Check out"
    }
  },
  "wifi": {
    "title": "Connect to the Wi-Fi network"
  }
}
